import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "Store/configureStore";

export const observabilityPipelineSelector = (state: RootState) =>
  state.observabilityPipeline;

export const observabilityPipelineHttpClients = createSelector(
  observabilityPipelineSelector,
  ({ clients }) => clients
);

export const observabilityPipelineHttpClientsLoadingState = createSelector(
  observabilityPipelineSelector,
  ({ clientsLoadingState }) => clientsLoadingState
);

export const observabilityPipelineHttpClient = createSelector(
  observabilityPipelineSelector,
  (
    _: RootState,
    params: {
      projectId: string;
      environmentId: string;
    }
  ) => params,
  (clients, { environmentId, projectId }) =>
    clients[`${projectId}/${environmentId}`] ?? null
);
